const EARTH_RADIUS_KM = 6371;

/** Great-circle distance between two WGS84 points in kilometers. */
export function haversineDistanceKm(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const toRad = (deg: number) => (deg * Math.PI) / 180;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return EARTH_RADIUS_KM * c;
}

/** Human-readable km for branch "distance from region" fields. */
export function formatDistanceKm(km: number): string {
    if (!Number.isFinite(km) || km < 0) return '';
    if (km < 1) return `${km.toFixed(2)} km`;
    return `${km.toFixed(1)} km`;
}
